import { ActiveTournamentPlanDto, ResponseActiveTournamentPlanDto } from '../interfaces/dto';
import graphqlResource, { GraphqlResource } from '../../../core/graphql-resource';

import { Organizer } from '../interfaces/organizer';
import { OrganizersDto } from '../interfaces/organizer-dto';
import { OrganizersDataMapper } from '../data-mappers/organizers.data-mapper';

export class OrganizersRepository {
  constructor(private readonly graphqlResource: GraphqlResource) {}

  async fetchOrganizers(): Promise<Organizer[]> {
    const query = `#graphql
      query getTournamentsDetails {
        tournaments {
          id
          name
          sportType
          phone
          email
          createdAt
          description
          images {
            type
            externalUrl
            createdAt
          }
          address {
            id
            city
            country
          }
          adminUser {
            id
            name
            surname
            middleName
            createdAt
            updatedAt
            wallet {
              balanceInMinorUnits
            }
          }
        }
      }
    `;

    const response = await this.graphqlResource.query<OrganizersDto>(query);
    const dataMapper = new OrganizersDataMapper();
    return dataMapper.decode(response.data.data.tournaments);
  }

  async fetchOrganizerPlan(tournamentId: number): Promise<ActiveTournamentPlanDto | null> {
    const query = `#graphql
      query getTournamentsDetails($tournamentId: Int!) {
        activeTournamentPlan(tournamentId: $tournamentId) {
          id
          name
          priceInMinorUnits
          features {
            id
            featureLimit
            createdAt
            updatedAt
            feature
          }
          createdAt
          updatedAt
          period
        }
      }
    `;

    const response = await this.graphqlResource.query<ResponseActiveTournamentPlanDto>(query, { tournamentId });
    if (response.data?.error) {
      console.debug({ response: response.data?.error });
      return null;
    }

    return response.data.data.activeTournamentPlan;
  }
}

const organizersRepository = new OrganizersRepository(graphqlResource);
export default organizersRepository;
